export class RiskTypeIconConstants {
  static readonly ATV = 'icon-atv';
  static readonly WATERCRAFT = 'icon-boat';
  static readonly MOTORCYCLE = 'icon-motorcycle';
  static readonly RV = 'icon-rv';
  static readonly SNOWMOBILE = 'icon-snowmobile';
  static readonly FARMMACHINERY = 'icon-farm';
}
